<template>
  <TopbarSpeedDial v-if="!readOnlyUser" :buttons="buttonsConfig" :routeKey="routeKey"/>
</template>


<script>
/* @flow */
const TopbarSpeedDial = () =>
  import(/* webpackChunkName: "TopbarSpeedDial" */ '@/components/TopbarSpeedDial')

export default {
  name: 'UserSpeedDial',
  props: {
    routeName: {type: String, default: ''},
    routeKey: {type: String, default: ''},
  },
  data() {
    return {
      buttonsConfig: [
        {
          label: 'Invite a Person',
          icon: 'add',
          to: 'new',
        },
      ],
    }
  },
  computed: {
    readOnlyUser() {
      const {roles_mask: rolesMask} = this.$store.getters.currentUser
      return rolesMask === 16 || rolesMask === 8
    },
  },
  components: {
    TopbarSpeedDial,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/UserSpeedDial.vue